import { render, staticRenderFns } from "./InboxReports.vue?vue&type=template&id=2e7ed334&"
import script from "./InboxReports.vue?vue&type=script&lang=js&"
export * from "./InboxReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7ed334')) {
      api.createRecord('2e7ed334', component.options)
    } else {
      api.reload('2e7ed334', component.options)
    }
    module.hot.accept("./InboxReports.vue?vue&type=template&id=2e7ed334&", function () {
      api.rerender('2e7ed334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/InboxReports.vue"
export default component.exports